module.exports = __webpack_public_path__ + "img/package.74d651eb.png";